import { connect } from 'react-redux';
import { getActiveProgram } from 'dux/router/selectors';
import { progress } from '@biw/contests-core';
import { ProgramModel } from '@biw/contests-core/lib/dux/programs';

export const mapStateToProps = ( state: any ) => {
    const program = getActiveProgram( state ) || {} as ProgramModel;
    return {
        dataThrough: progress.selectors.getProgramViewProgressLastUpdated( state, program.programViewId ),
        program,
    };
};

export default connect( mapStateToProps );
